import { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SurchargeOption, SurchargeRelations } from '../types';

import { schema } from '../utils/schema';

import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import useSave from '../hooks/useSave';
import { CostCentersSelect } from './CostCentersSelect';
import { SurchargesSelect } from './SurchargesSelect';
import {
  GridContainer,
  GridCompact12
} from 'components/shared/Grid/Grid.components';

interface Props {
  handleClose: () => void;
  data: SurchargeRelations | null;
}

const SurchargeRelationsForm = ({ handleClose, data }: Props) => {
  const { t } = useTranslation('common');
  const { mutate } = useSave(!!data, handleClose);
  const [selectedSurcharge, setSelectedSurcharge] =
    useState<SurchargeOption | null>(null);
  const methods = useForm({
    defaultValues: data ? schema.cast(data) : undefined,
    resolver: yupResolver(schema)
  });

  const onSubmit = (data) => {
    const updatedData = {
      ...data,
      surchargeCode: selectedSurcharge?.value,
      surchargeId: selectedSurcharge?.surchargeId,
      surchargeName: selectedSurcharge?.label
    };
    mutate(updatedData);
  };

  return (
    <>
      <MultiStepForm methods={methods} onSubmit={onSubmit}>
        <MultiStepForm.Section
          title={t('surchargeRelations.formSectionLabels.basis')}
          validateFields={[
            'brEmployerLinkClientId',
            'employerBrDynId',
            'surchargeId'
          ]}
        >
          <GridContainer>
            <GridCompact12>
              <CostCentersSelect
                name="clientBrDynId"
                label={t('surchargeRelations.client')}
              />
            </GridCompact12>
            <GridCompact12>
              <CostCentersSelect
                name="employerBrDynId"
                label={t('surchargeRelations.employer')}
              />
            </GridCompact12>
            <GridCompact12>
              <SurchargesSelect setSelectedSurcharge={setSelectedSurcharge} />
            </GridCompact12>
          </GridContainer>
        </MultiStepForm.Section>
        <MultiStepForm.Actions>
          <Box display="flex" ml="auto">
            <LoadingButton
              loading={false}
              type="submit"
              variant="contained"
              autoFocus
              color="primary"
            >
              {t('save')}
            </LoadingButton>
          </Box>
        </MultiStepForm.Actions>
      </MultiStepForm>
    </>
  );
};

export default SurchargeRelationsForm;
